import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Protected({ Component }) {
  const navigate = useNavigate();
  const EXPIRY_TIME = 30 * 60 * 1000;

  useEffect(() => {
    const token = localStorage.getItem("token");
    const loginTime = localStorage.getItem("loginTime");

    if (!token || !loginTime) {
      navigate("/");
      return;
    }

    const diff = Date.now() - Number(loginTime);

    if (diff >= EXPIRY_TIME) {
      localStorage.clear();
      navigate("/");
      return;
    }

    const timer = setTimeout(() => {
      localStorage.clear();
      navigate("/");
    }, EXPIRY_TIME - diff);

    return () => clearTimeout(timer);
  }, [navigate]);

  return <Component />;
}

export default Protected;